import ApiHelper from './apiHelper'

const service = new ApiHelper({
  // api_url:'https://private-72dac41-upcree.apiary-mock.com',
  // api_url:'https://tiw9aqrpwh.execute-api.us-east-1.amazonaws.com/Prod',
  api_url: 'https://dz54vqm12f.execute-api.us-east-1.amazonaws.com/Prod',
  token: ''
})

export default service
